<section class="">

    <div class="flex justify-between items-end">
        <div>
            <h1>Message Broadcasting</h1>
        </div>
        <div *ngIf="isCreateMessageVisible">
            <a [routerLink]="['create']"  class="btn btn-sm flex items-center btn-primary"><i class="ri-add-line"></i>
                Create Message</a>
        </div>
    </div>

    <div class="mt-5 grid grid-cols-4 grid-rows-1 ">

        <div class="col-span-1 pr-5   ">

            <ul class="flex flex-col gap-1.5 bg-white rounded-lg pl-0 p-5 sticky top-5">
                @for (tab of tabs; track $index) {
                <li class="flex justify-between items-center py-2 px-3 text-zinc-400 cursor-pointer"
                    (click)="currentTab = tab.identifier"
                    [ngClass]="{'bg-blue-50 rounded-r-md border-l-4 border-blue-600 text-blue-600 font-semibold': currentTab === tab.identifier}">
                    <span class="">{{ tab.label }}</span>
                    <div class="badge badge-sm py-1 font-medium"
                        [ngClass]="{'bg-blue-600 text-white': currentTab === tab.identifier, 'bg-zinc-100 text-zinc-600': currentTab !== tab.identifier}">
                        {{ tab.count }}</div>
                </li>
                }
            </ul>

        </div>

        <div class="col-span-3 h-full">

            <div class="grid grid-cols-6 gap-2 place-content-between">

                <div class="col-span-1">
                    <select class="select w-full select-bordered bg-white select-sm">
                        <option disabled selected>Course</option>
                        <option>Course 1</option>
                        <option>Course 2</option>
                        <option>Course 3</option>
                        <option>Course 4</option>
                        <option>Course 5</option>
                    </select>
                </div>

                <div class="col-span-1">
                    <select class="select w-full select-bordered bg-white select-sm" (change)="setFields($event,'department')">
                        <option disabled selected>Department</option>
                        @for (i of departments || []; track $index) {
                            <option class="text-sm font-medium" [value]="i?.id">{{ i?.department_name }}</option>
                        }
                    </select>
                </div>

                <div class="col-span-1">
                    <select class="select w-full select-bordered bg-white select-sm" (change)="setFields($event,'class')">
                        <option disabled selected>Class</option>
                        @for (i of classes || []; track $index) {
                            <option class="text-sm font-medium" [value]="i?.id">{{ i?.class_name }}</option>
                        }
                    </select>
                </div>

                <div class="col-span-1">
                    <select class="select w-full select-bordered bg-white select-sm">
                        <option disabled selected>Batch</option>
                        @for (i of batches || []; track $index) {
                            <option class="text-sm font-medium" [value]="i?.id">{{ i?.batch_name }}</option>
                        }
                    </select>
                </div>

                <div class="col-span-1">
                    <select class="select w-full select-bordered bg-white select-sm">
                        <option disabled selected>Academic Year</option>
                        <option>Year 1</option>
                        <option>Year 2</option>
                        <option>Year 3</option>
                        <option>Year 4</option>
                        <option>Year 5</option>
                    </select>
                </div>

                <div class="col-span-1">
                    <select class="select w-full select-bordered bg-white select-sm">
                        <option disabled selected>Group</option>
                        <option>Group 1</option>
                        <option>Group 2</option>
                        <option>Group 3</option>
                        <option>Group 4</option>
                        <option>Group 5</option>
                    </select>
                </div>

                <div class="col-span-2">
                    <label class="input input-sm input-bordered flex items-center gap-2">
                        <i class="ri-search-2-line"></i>
                        <input type="text" class="grow" placeholder="Search" />
                    </label>
                </div>
                <span class="col-span-3"></span>
                <button class="col-span-1 btn btn-sm btn-primary">
                    Apply
                </button>

            </div>


            <div class="mt-5 p-3 rounded-lg bg-white overflow-y-auto " *ngIf="isInboxview">
                <div class="overflow-x-auto">
                    <table class="table">
                        <!-- head -->
                        <!-- <thead>
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Job</th>
                                <th>Favorite Color</th>
                            </tr>
                        </thead> -->
                        <tbody>
                            <!-- row 1 -->
                            @for (message of inboxList; track $index) {
                            <tr class="cursor-pointer">
                                <!-- <th>1</th> -->
                                <td class="">
                                    <div class="flex items-center gap-2">
                                        <p class="text-sm mb-1 max-w-[18rem] line-clamp-1" [ngClass]="{'font-semibold': message.type === 'notification', 'font-medium': message.type != 'notification',}" >{{message.title}}</p>
                                        @if (message.type === 'notification') {
                                            <span class="badge badge-sm bg-blue-600 text-white">new</span>
                                        }
                                    </div>
                                    <span class="text-xs text-zinc-500 line-clamp-2">{{message.message}} </span>
                                </td>
                                <td class="uppercase text-xs font-medium">{{message.type}}</td>
                                <td class="text-xs text-nowrap">{{message.date | date}}</td>
                            </tr>
                            }

                        </tbody>
                    </table>
                </div>
            </div>

            <div class="flex justify-center mt-3" *ngIf="isInboxview">
                <app-pagination></app-pagination>
            </div>

        </div>


    </div>

</section>